module.exports = __webpack_public_path__ + "img/P90x.a07bf790.jpg";